import React, {useState, useEffect} from 'react';
import './CardDetails.less';
import {StripeInputWrapper} from "elements/stripe-input-wrapper/StripeInputWrapper";
import {CardCvcElement, CardExpiryElement, CardNumberElement} from "@stripe/react-stripe-js";
import {HSLToHex, parseRGB, RGBToHex} from "../../../../color-scheme-generator/modules/helpers/color.helper";

const inputStyle = {
	base: {
		color: '#ffffff',
		fontWeight: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.02px',
		fontFamily: ' -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\',\n    \'Helvetica Neue\', sans-serif',
		fontSize: '14px',
		fontSmoothing: 'antialiased',

		'::placeholder': {
			color: 'rgba(255, 255, 255, 0.36)',
		},
		':-webkit-autofill': {
			color: '#e39f48',
		},
	},
	invalid: {
		color: '#ef9e99',

		'::placeholder': {
			color: 'rgba(255, 255, 255, 0.36)',
		},
	},
}


export const CardDetails = () => {

	const [fontColor, setFontColor] = useState('#ffffff');

	useEffect(() => {
		try {
			const dummyDiv = document.createElement('div');
			dummyDiv.style.setProperty('background-color', 'hsl(var(--group-card-font-color-h), var(--group-card-font-color-s), var(--group-card-font-color-l))')
			dummyDiv.id = 'dummy-div';
			document.body.appendChild(dummyDiv);
			const computedColor = getComputedStyle(dummyDiv).backgroundColor;
			document.body.removeChild(dummyDiv);
			const parsedColor = parseRGB(computedColor);

			setFontColor(RGBToHex(parsedColor?.r, parsedColor?.g, parsedColor?.b));
		} catch (e) {
			setFontColor('#ffffff');
		}

	}, []);

	const currentStyle = {
		...inputStyle,
		base: {
			...inputStyle.base,
			color: fontColor
		}
	}
	return <div className="card-details">
		<div className="card-details__number">
			<StripeInputWrapper>
				<CardNumberElement
					options={{
						style: currentStyle
					}}
				/>
			</StripeInputWrapper>
		</div>
		<div className="card-details__container">
			<div className="card-details__expiry">
				<StripeInputWrapper>
					<CardExpiryElement
						options={{
							style: currentStyle
						}}
					/>
				</StripeInputWrapper>
			</div>
			<div className="card-details__cvc">
				<StripeInputWrapper>
					<CardCvcElement
						options={{
							style: currentStyle
						}}
					/>
				</StripeInputWrapper>
			</div>
		</div>
	</div>
}
